import client from '@libs/HttpClient';
class RecruitmentCitiesService {
  static listRecruitmentCities(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    return client.get(
      `/recruitment-cities/?search=${searchText}&page=${page_no}&status=${status}`,
      request
    );
  }
  static addRecruitmentCities(request) {
    return client.post('/recruitment-cities', request);
  }
  static showRecruitmentCities(params) {
    return client.get(`/recruitment-cities/${params}`);
  }
  static viewRecruitmentCities(params) {
    return client.get(`/recruitment-cities/${params}/edit`);
  }
  static updateRecruitmentCities(request) {
    return client.put(`/recruitment-cities/${request.id}`, request);
  }
  static deleteRecruitmentCities(request) {
    return client.delete(`/recruitment-cities/${request.id}`, request);
  }
  static changeStatusRecruitmentCities(request) {
    return client.patch(`/recruitment-cities/change-status/${request.id}`, request);
  }
}
export { RecruitmentCitiesService };
